import { request } from './client';

import { unwrapApiData, unwrapApiResponse } from '../utils/apiResponse';



export async function register(body) {

  const { data, message } = unwrapApiResponse(await request('/auth/register', { method: 'POST', body }));

  return { ...data, _message: message };

}



export async function login(body) {

  return unwrapApiData(await request('/auth/login', { method: 'POST', body }));

}



export async function refreshToken(refreshToken) {

  return unwrapApiData(await request('/auth/refresh', {

    method: 'POST',

    body: { refreshToken },

  }));

}



export async function verifyEmail(body) {

  return unwrapApiData(await request('/auth/verify-email', { method: 'POST', body }));

}



export async function resendVerification(email) {

  const { message } = unwrapApiResponse(await request('/auth/resend-verification', { method: 'POST', body: { email } }));

  return message;

}



export async function forgotPassword(email) {

  const { message } = unwrapApiResponse(await request('/auth/forgot-password', { method: 'POST', body: { email } }));

  return message;

}



export async function resetPassword(body) {

  return unwrapApiData(await request('/auth/reset-password', { method: 'POST', body }));

}



export async function fetchMe() {

  return unwrapApiData(await request('/auth/me'));

}



export async function fetchQuotaPlans() {

  return unwrapApiData(await request('/quota/plans'));

}



export async function fetchMyQuota() {

  return unwrapApiData(await request('/quota/me'));

}

